import i18next from 'i18next';

export function autoTranslate(root: HTMLElement = document.body) {
  const walker = document.createTreeWalker(
    root,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode(node: Node) {
        const text = node.textContent?.trim();
        // Ignore empty text or whitespace
        if (!text || text.length === 0) return NodeFilter.FILTER_SKIP;
        // Only allow uppercase-like keys (HELLO, SAVE_BUTTON, etc.)
        if (/^[A-Z0-9._-]+$/.test(text)) return NodeFilter.FILTER_ACCEPT;
        return NodeFilter.FILTER_SKIP;
      },
    }
  );

  let node;
  while ((node = walker.nextNode())) {
    const key = node.textContent!.trim();
    const translated = i18next.t(key);
    node.textContent = translated;
  }
}
